// import Cookies from "js-cookie";

// export const setToken = (token) => {
//   Cookies.set("MGAIGC-TEST", token);
// };

// export const getToken = () => {
//   return Cookies.get("MGAIGC-TEST");
// };

// export const clearToken = () => {
//   Cookies.remove("MGAIGC-TEST");
// };

export const setUserData = (userData) => {
  localStorage.setItem("user-data", JSON.stringify(userData));
};

export const getUserData = () => {
  return JSON.parse(localStorage.getItem("user-data") || "{}");
};

export const clearUserData = () => {
  localStorage.removeItem("user-data");
};

export const isLogin = () => {
  return !!getUserData()?.id;
};

// 是否管理员
// export const isManager = () => {
//   return !!getUserData().isManager;
// };

// 是否评审
// export const isJudge = () => {
//   return !!getUserData().isJudge;
// };
